/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_ValueInputs */

const en_plan_best_value = /** @type {(inputs: Plan_Best_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best value`)
};

const es_plan_best_value = /** @type {(inputs: Plan_Best_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor valor`)
};

/**
* | output |
* | --- |
* | "Best value" |
*
* @param {Plan_Best_ValueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_best_value = /** @type {((inputs?: Plan_Best_ValueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_ValueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_best_value(inputs)
	return en_plan_best_value(inputs)
});